import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/lottery/tip1.png';
import _imports_1 from '@assets/images/lottery/tip2.png';
import _imports_2 from '@assets/images/lottery/wait.png';
import _imports_3 from '@assets/images/lottery/noniubi.png';
import _imports_4 from '@assets/images/lottery/task1@2x.png';
import _imports_5 from '@assets/images/lottery/task2@2x.png';
import _imports_6 from '@assets/images/lottery/task3@2x.png';
import _imports_7 from '@assets/images/lottery/no.png';
const _withScopeId = n => (_pushScopeId("data-v-4a8056ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixd-box"
};
const _hoisted_2 = {
  key: 0,
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "modian-icon icon-60arrowleft"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "modian-icon icon-60rule2"
}, null, -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "modian-icon icon-60gift"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-list2"
}, null, -1));
const _hoisted_12 = {
  class: "noappBox"
};
const _hoisted_13 = {
  class: "header"
};
const _hoisted_14 = {
  class: "header-bg"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "op-div"
}, null, -1));
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "header-content"
};
const _hoisted_18 = {
  class: "img"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sign"
}, null, -1));
const _hoisted_20 = {
  class: "img-box"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "prize"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rank"
}, "第1名获得", -1));
const _hoisted_24 = {
  class: "title"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num"
}, "×1", -1));
const _hoisted_26 = {
  class: "prize"
};
const _hoisted_27 = {
  class: "rank"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  class: "num"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr"
}, null, -1));
const _hoisted_31 = {
  class: "text"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, null, -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr",
  style: {
    "margin-top": "0"
  }
}, null, -1));
const _hoisted_34 = {
  class: "sum-box"
};
const _hoisted_35 = {
  class: "pric"
};
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 已筹 ");
const _hoisted_37 = {
  class: "sum"
};
const _hoisted_38 = {
  key: 0,
  class: "time"
};
const _hoisted_39 = {
  key: 1,
  class: "time"
};
const _hoisted_40 = {
  class: "schedule"
};
const _hoisted_41 = {
  class: "user-box"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  class: "user-name"
};
const _hoisted_44 = {
  class: "user-num"
};
const _hoisted_45 = {
  class: "delivery-time"
};
const _hoisted_46 = {
  key: 0,
  class: "title"
};
const _hoisted_47 = {
  key: 0,
  class: "bet1"
};
const _hoisted_48 = {
  class: "input-box"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ico"
}, "¥", -1));
const _hoisted_50 = {
  class: "input"
};
const _hoisted_51 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass(['bet4'])
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "win-tit"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "获得实物、称号奖品"), /*#__PURE__*/_createElementVNode("div", {
  class: "line"
})], -1));
const _hoisted_53 = {
  class: "ul"
};
const _hoisted_54 = {
  class: "user-img"
};
const _hoisted_55 = ["src"];
const _hoisted_56 = {
  class: "user-name"
};
const _hoisted_57 = {
  class: "price"
};
const _hoisted_58 = {
  key: 0,
  class: "win-tit"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "获得称号奖品", -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_61 = [_hoisted_59, _hoisted_60];
const _hoisted_62 = {
  key: 1,
  class: "ul"
};
const _hoisted_63 = {
  class: "user-img"
};
const _hoisted_64 = ["src"];
const _hoisted_65 = {
  class: "user-name"
};
const _hoisted_66 = {
  class: "price"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "modian-icon icon-60arrow"
}, null, -1));
const _hoisted_68 = {
  key: 3,
  class: "bet5"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(['bt'])
}, "等待开奖中", -1));
const _hoisted_71 = [_hoisted_69, _hoisted_70];
const _hoisted_72 = {
  key: 4,
  class: "bet9"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(['bt'])
}, "很遗憾，无预言家诞生", -1));
const _hoisted_75 = [_hoisted_73, _hoisted_74];
const _hoisted_76 = {
  key: 5,
  class: "integral-box"
};
const _hoisted_77 = {
  key: 0,
  class: "rule"
};
const _hoisted_78 = {
  key: 1,
  class: "xian"
};
const _hoisted_79 = {
  class: "integral"
};
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 还可预言 ");
const _hoisted_81 = {
  class: "num"
};
const _hoisted_82 = /*#__PURE__*/_createTextVNode("次 ");
const _hoisted_83 = {
  class: "task-box"
};
const _hoisted_84 = {
  class: "task-li"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_86 = {
  class: "center"
};
const _hoisted_87 = {
  class: "h3"
};
const _hoisted_88 = {
  class: "p"
};
const _hoisted_89 = {
  class: "black"
};
const _hoisted_90 = /*#__PURE__*/_createTextVNode("预言 ");
const _hoisted_91 = {
  class: "num"
};
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" 次");
const _hoisted_93 = {
  class: "task-li"
};
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})], -1));
const _hoisted_95 = {
  class: "center"
};
const _hoisted_96 = {
  class: "h3"
};
const _hoisted_97 = {
  class: "p"
};
const _hoisted_98 = /*#__PURE__*/_createTextVNode("我的积分 ");
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" 还可兑换 ");
const _hoisted_100 = {
  class: "num"
};
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" 次 ");
const _hoisted_102 = {
  class: "task-li"
};
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
})], -1));
const _hoisted_104 = {
  class: "center"
};
const _hoisted_105 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3"
}, "每邀请一个好友助力可+1次", -1));
const _hoisted_106 = {
  class: "p"
};
const _hoisted_107 = /*#__PURE__*/_createTextVNode("还可助力 ");
const _hoisted_108 = {
  class: "num"
};
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" 次");
const _hoisted_110 = {
  class: "record-box"
};
const _hoisted_111 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "- 我的预言记录 -", -1));
const _hoisted_112 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr"
}, null, -1));
const _hoisted_113 = {
  key: 0,
  class: "ul"
};
const _hoisted_114 = {
  class: "top"
};
const _hoisted_115 = {
  class: "num"
};
const _hoisted_116 = {
  class: "number-time"
};
const _hoisted_117 = {
  class: "number"
};
const _hoisted_118 = {
  class: "time"
};
const _hoisted_119 = {
  class: "success_bet_money_list"
};
const _hoisted_120 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li-hr"
}, null, -1));
const _hoisted_121 = {
  key: 1,
  class: "null"
};
const _hoisted_122 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_123 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "您暂未参与预言", -1));
const _hoisted_124 = [_hoisted_122, _hoisted_123];
const _hoisted_125 = {
  class: "mask-bg"
};
const _hoisted_126 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "全部用户“预言金额”", -1));
const _hoisted_127 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr"
}, null, -1));
const _hoisted_128 = {
  key: 0,
  class: "ul"
};
const _hoisted_129 = {
  class: "img"
};
const _hoisted_130 = ["src"];
const _hoisted_131 = {
  class: "content"
};
const _hoisted_132 = {
  class: "name"
};
const _hoisted_133 = {
  class: "time"
};
const _hoisted_134 = {
  class: "price"
};
const _hoisted_135 = {
  key: 0,
  class: "mask-bg b"
};
const _hoisted_136 = {
  class: "show-box"
};
const _hoisted_137 = {
  class: "show-box-title"
};
const _hoisted_138 = {
  class: "show-box-content"
};
const _hoisted_139 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "show-box-content-text"
}, "距开始剩余", -1));
const _hoisted_140 = {
  class: "show-box-content-time"
};
const _hoisted_141 = {
  class: "show-box-content-time-num"
};
const _hoisted_142 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1));
const _hoisted_143 = {
  class: "show-box-content-time-num"
};
const _hoisted_144 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时", -1));
const _hoisted_145 = {
  class: "show-box-content-time-num"
};
const _hoisted_146 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分", -1));
const _hoisted_147 = {
  class: "show-box-content-time-num"
};
const _hoisted_148 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "秒", -1));
const _hoisted_149 = {
  key: 1,
  class: "show-box-content-tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompProphet = _resolveComponent("CompProphet");
  return $data.detailData ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "lottery",
    style: _normalizeStyle($data.allShow ? 'height:100vh' : '')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['headerbt', $data.localTop > 176 ? 'localTop' : '', {
      weixin: $data.env.isWxApp()
    }]),
    style: _normalizeStyle({
      background: 'rgba(255,255,255,' + $data.localTop / 1.76 + '%)',
      height: $data.statusBarH ? 'calc(2.346667rem + ' + $data.statusBarH + ')' : '2.346667rem'
    })
  }, [$data.localTop > 176 ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($data.detailData.pro_title), 1)) : _createCommentVNode("", true), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "rule",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goToRule && $options.goToRule(...args))
  }, _hoisted_7), _createElementVNode("div", {
    class: "all",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goToAll && $options.goToAll(...args))
  }, _hoisted_10)], 6), _createElementVNode("div", {
    class: _normalizeClass(['footer', {
      isIphoneX: $data.isIphoneX
    }])
  }, [_createElementVNode("div", {
    class: "text",
    onClick: _cache[3] || (_cache[3] = $event => $options.bet_info(true, 'open'))
  }, [_hoisted_11, _createTextVNode(" 查看" + _toDisplayString($data.detailData.record_total) + "条“预言金额” ", 1)])], 2)]), _createElementVNode("div", _hoisted_12, [!$data.env.isModianIos() && !$data.env.isModianAndroid() && !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "noapp",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.noApp && $options.noApp(...args))
  })) : _createCommentVNode("", true), !$data.user_id ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "noapp",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.login && $options.login(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("img", {
    src: $data.detailData.prize_pic,
    alt: ""
  }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
    src: $data.detailData.prize_pic,
    alt: ""
  }, null, 8, _hoisted_21)])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString($data.detailData.main_prize_title), 1), _hoisted_25]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, "前" + _toDisplayString($data.detailData.sub_prize_people_num) + "名获得", 1), _createElementVNode("div", _hoisted_28, _toDisplayString($data.detailData.sub_prize_title), 1), _createElementVNode("div", _hoisted_29, "×" + _toDisplayString($data.detailData.sub_prize_people_num), 1)]), _hoisted_30, _createElementVNode("div", {
    class: "project-title",
    onClick: _cache[6] || (_cache[6] = $event => $options.goToProject($data.detailData.pro_info.id))
  }, [_createElementVNode("div", _hoisted_31, "众筹项目：" + _toDisplayString($data.detailData.pro_info.name), 1), _hoisted_32]), _hoisted_33, _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("span", _hoisted_37, " ¥" + _toDisplayString($options.moneyFilter($data.detailData.pro_info.backer_money)) + _toDisplayString($data.detailData.pro_info.backer_money ? $data.detailData.pro_info.backer_money.split(".")[1] ? $data.detailData.pro_info.backer_money.split(".")[1] == 0 ? ".00" : "" : "" : ""), 1)]), $data.statusType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_38, "已结束")) : $data.detailData.open_time ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString($data.detailData.open_time) + " 结束预言", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", {
    class: "schedule-green",
    style: _normalizeStyle({
      width: $data.greenNum + '%'
    })
  }, null, 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.my_quiz_info, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "origin",
      key: idx,
      style: _normalizeStyle({
        left: item.left + '%',
        width: '1%'
      })
    }, null, 4);
  }), 128))]), _createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.out_list, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "user",
      key: idx
    }, [item.icon ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "user-img",
      src: item.icon
    }, null, 8, _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, _toDisplayString(item.nickname), 1), _createElementVNode("div", _hoisted_44, "预言 ¥" + _toDisplayString($options.moneyFilter(item.amount)), 1)]);
  }), 128)), _createElementVNode("div", _hoisted_45, _toDisplayString($data.detailData.deliver_time), 1)])])]), _createElementVNode("div", {
    class: _normalizeClass(['lottert-content', {
      winbg: $data.winbg
    }])
  }, [$data.statusType != -2 ? (_openBlock(), _createElementBlock("div", _hoisted_46, "- " + _toDisplayString($data.statusTypeMap[$data.statusType]) + " -", 1)) : _createCommentVNode("", true), $data.statusType == 1 || $data.statusType == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.lotter == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
    class: _normalizeClass(['input-border', {
      disabled: $data.detailData.available_times === 0 ? true : ''
    }])
  }, [_hoisted_49, _createElementVNode("div", _hoisted_50, [_withDirectives(_createElementVNode("input", {
    type: "number",
    oninput: "if(value>99999999){value=99999999}else if(value<0){value=0}else{value = parseInt(value)}",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.start_money = $event),
    placeholder: "输入预测的金额"
  }, null, 512), [[_vModelText, $data.start_money]])]), $data.detailData.prompt ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "random",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.getRandom && $options.getRandom(...args))
  }, "随机")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
    class: _normalizeClass(['bt', {
      disabled: $data.detailData.available_times === 0 ? true : ''
    }]),
    onClick: _cache[9] || (_cache[9] = (...args) => $options.betOneFn && $options.betOneFn(...args))
  }, " 发起预言 ", 2)])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.statusType == 3 && $data.detailData.prize_list && $data.detailData.prize_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [_createElementVNode("div", {
    class: _normalizeClass(['user', {
      win: $data.detailData.prize_list[0].self
    }])
  }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("img", {
    src: $data.detailData.prize_list[0].icon,
    alt: ""
  }, null, 8, _hoisted_55)]), _createElementVNode("div", _hoisted_56, [_createTextVNode(_toDisplayString($data.detailData.prize_list[0].nickname) + " ", 1), _createElementVNode("div", _hoisted_57, "预言金额 ¥" + _toDisplayString($data.detailData.prize_list[0].amount), 1)])], 2)]), $data.detailData.sub_prize_people_num > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61)) : _createCommentVNode("", true), $data.detailData.sub_prize_people_num > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detailData.prize_list.slice(1, 10), (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      key: idx,
      class: _normalizeClass(['user', {
        win: item.self
      }])
    }, [_createElementVNode("div", _hoisted_63, [_createElementVNode("img", {
      src: item.icon,
      alt: ""
    }, null, 8, _hoisted_64)]), _createElementVNode("div", _hoisted_65, [_createTextVNode(_toDisplayString(item.nickname) + " ", 1), _createElementVNode("div", _hoisted_66, "¥" + _toDisplayString(item.amount), 1)])], 2);
  }), 128))])) : _createCommentVNode("", true), $data.winbg ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(['bt']),
    onClick: _cache[10] || (_cache[10] = (...args) => $options.gotoRong && $options.gotoRong(...args))
  }, [_createTextVNode(_toDisplayString($data.detailData.prize_list[0].self ? '联系客服领奖' : '个人主页查看“称号”') + " ", 1), _hoisted_67])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.statusType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71)) : _createCommentVNode("", true), $data.statusType == 9 ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_75)) : _createCommentVNode("", true), $data.statusType == 1 || $data.statusType == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_76, [$data.detailData.prompt ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString($data.detailData.prompt), 1)) : _createCommentVNode("", true), $data.detailData.prompt ? (_openBlock(), _createElementBlock("div", _hoisted_78)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("div", _hoisted_81, _toDisplayString($data.detailData.available_times), 1), _hoisted_82])])) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, "当前众筹累计支持满¥" + _toDisplayString($data.detailData.receive_info.pro_amount), 1), _createElementVNode("div", _hoisted_88, [_createTextVNode("已支持¥" + _toDisplayString($data.detailData.receive_info.support_amount) + "/¥" + _toDisplayString($data.detailData.receive_info.pro_amount) + " ", 1), _createElementVNode("span", _hoisted_89, [_hoisted_90, _createElementVNode("span", _hoisted_91, "+" + _toDisplayString($data.detailData.receive_info.receive_num), 1), _hoisted_92])])]), _createElementVNode("div", {
    class: _normalizeClass(['btn', {
      dis: $data.detailData.receive_info.status === 1 || $data.statusType !== 1
    }]),
    onClick: _cache[11] || (_cache[11] = $event => $options.taskBt1($data.detailData.receive_info))
  }, _toDisplayString($data.detailData.receive_info.status ? $data.receive_info_Map[$data.detailData.receive_info.status] : '去支持'), 3)]), _createElementVNode("div", _hoisted_93, [_hoisted_94, _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, "消耗" + _toDisplayString($data.detailData.receive_info.consumer_integral) + "积分兑换", 1), _createElementVNode("div", _hoisted_97, [_hoisted_98, _createElementVNode("span", {
    onClick: _cache[12] || (_cache[12] = (...args) => $options.touserscore && $options.touserscore(...args)),
    class: "gree"
  }, _toDisplayString($data.detailData.receive_info.integral_amount), 1), _hoisted_99, _createElementVNode("span", _hoisted_100, _toDisplayString($data.detailData.receive_info.redeemed_num) + "/" + _toDisplayString($data.detailData.receive_info.max_exchange_num), 1), _hoisted_101])]), _createElementVNode("div", {
    class: _normalizeClass(['btn', {
      dis: ($data.detailData.receive_info.redeemed_num === 0 || $data.statusType !== 1) && $data.detailData.receive_info.integral_amount > 0
    }]),
    onClick: _cache[13] || (_cache[13] = (...args) => $options.taskBt2 && $options.taskBt2(...args))
  }, _toDisplayString($data.detailData.receive_info.integral_amount > 0 ? '兑换' : '赚积分'), 3)]), _createElementVNode("div", _hoisted_102, [_hoisted_103, _createElementVNode("div", _hoisted_104, [_hoisted_105, _createElementVNode("div", _hoisted_106, [_hoisted_107, _createElementVNode("span", _hoisted_108, _toDisplayString($data.detailData.receive_info.assisted_num) + "/" + _toDisplayString($data.detailData.receive_info.max_assist_num), 1), _hoisted_109])]), _createElementVNode("div", {
    class: _normalizeClass(['btn', {
      dis: $data.detailData.receive_info.assisted_num === 0 || $data.statusType !== 1
    }]),
    onClick: _cache[14] || (_cache[14] = (...args) => $options.taskBt3 && $options.taskBt3(...args))
  }, " 去邀请 ", 2)])]), _createVNode(_component_CompProphet, {
    style: {
      "position": "relative",
      "z-index": "1000"
    },
    pro_id: $data.detailData.pro_info.id,
    activity_id: $data.activity_id
  }, null, 8, ["pro_id", "activity_id"]), _createElementVNode("div", _hoisted_110, [_hoisted_111, _hoisted_112, $data.detailData && $data.detailData.self_prophet_record_list && $data.detailData.self_prophet_record_list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_113, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detailData.self_prophet_record_list, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['li', item.out ? 'out' : '']),
      key: idx
    }, [_createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, _toDisplayString($data.detailData.self_prophet_record_list.length - idx), 1), _createElementVNode("div", _hoisted_116, [_createElementVNode("div", _hoisted_117, " ¥" + _toDisplayString(item.amount), 1), _createElementVNode("div", _hoisted_118, _toDisplayString(item.time), 1)]), _createElementVNode("div", _hoisted_119, _toDisplayString(item.rank), 1)]), _hoisted_120], 2);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_121, _hoisted_124))])]), _withDirectives(_createElementVNode("div", _hoisted_125, [_createElementVNode("div", {
    class: _normalizeClass(['mask-box', {
      isIphoneX: $data.isIphoneX
    }])
  }, [_createElementVNode("i", {
    class: "close modian-icon icon-60fork",
    onClick: _cache[15] || (_cache[15] = $event => $data.allShow = false)
  }), _hoisted_126, _hoisted_127, _createElementVNode("div", {
    class: "qujian",
    ref: "listScroll",
    onScroll: _cache[16] || (_cache[16] = $event => $options.listScroll($event))
  }, [$data.allList && $data.allList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_128, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allList, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "li",
      key: idx
    }, [_createElementVNode("div", _hoisted_129, [_createElementVNode("img", {
      src: item.icon,
      alt: "",
      srcset: ""
    }, null, 8, _hoisted_130)]), _createElementVNode("div", _hoisted_131, [_createElementVNode("div", _hoisted_132, _toDisplayString(item.nickname), 1), _createElementVNode("div", _hoisted_133, _toDisplayString(item.time), 1)]), _createElementVNode("div", _hoisted_134, " ¥" + _toDisplayString(item.amount), 1)]);
  }), 128))])) : _createCommentVNode("", true)], 544)], 2)], 512), [[_vShow, $data.allShow]]), $data.statusType == 0 || $data.statusType == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, [_createElementVNode("div", _hoisted_137, _toDisplayString($data.statusType == 0 ? "活动还未开始" : "活动已取消"), 1), _createElementVNode("div", _hoisted_138, [$data.statusType == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_139, _createElementVNode("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, _toDisplayString($data.day), 1), _hoisted_142, _createElementVNode("div", _hoisted_143, _toDisplayString($data.hour), 1), _hoisted_144, _createElementVNode("div", _hoisted_145, _toDisplayString($data.minute), 1), _hoisted_146, _createElementVNode("div", _hoisted_147, _toDisplayString($data.sec), 1), _hoisted_148])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_149, " 众筹未成功，此活动已取消。如果您参与过预言，您消耗的积分已返回至您的账户 "))]), _createElementVNode("div", {
    class: "show-box-bt",
    onClick: _cache[17] || (_cache[17] = (...args) => $options.close && $options.close(...args))
  }, "确定")])])) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true);
}